export const SET_VISIBILITY = 'setVisibility'
export const SET_TITLE = 'setTitle'
export const SET_ITEM = 'setItem'
export const SET_FORCED_SCROLL_BOTTOM = 'setForcedScrollBottom'
